import { VideoCategoryInterface } from '@app/interfaces/video-category.interface';
import { VideoInterface } from '@app/interfaces/video.interface';
import { Video } from '../models/_index';
import { Adapter } from './adapter';
import { CategoryAdapter } from './category.adapter';

/**
 * Adapts raw video CMS object to a Video Model
 * NOTE: The item fields are the default json property names.
 */
export class VideoAdapter implements Adapter<Video> {
  static adapt(arg0: any): any {
    throw new Error('Method not implemented.');
  }
  private categoryAdapter: CategoryAdapter;

  constructor() {
    this.categoryAdapter = new CategoryAdapter();
  }

  /**
   * Adapt data item into a Video model.
   * @param item - data item Video Interface to be transformed
   * @returns - returns an adapted Video model
   */
  adapt(item: VideoInterface): Video {
    let category: VideoCategoryInterface[];
    let video: Video;

    if (item && item.acf) {
      category = item.acf.video_category;
    }

    if (item && item.acf) {
      video = new Video(
        item.id,
        item.title && item.title.rendered,
        item.acf.embed,
        item.acf.external_url,
        item.acf.external_link_cta,
        item.acf.duration,
        item.acf.date_added,
        category.map((field: VideoCategoryInterface) => this.categoryAdapter.adapt(field)),
        item.content && item.content.rendered,
        item.slug
      );
    }
    return video;
  }
}
